var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDollar28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.454 26.731c-.468 0-.855-.162-1.161-.486a1.54 1.54 0 0 1-.46-1.134v-1.593c-1.043-.072-1.97-.234-2.78-.486a15.037 15.037 0 0 1-2.025-.837c-.504-.252-.82-.603-.945-1.053a2.069 2.069 0 0 1 .054-1.323c.18-.432.468-.738.864-.918.414-.198.9-.162 1.458.108.432.234 1.035.477 1.809.729.774.234 1.719.351 2.835.351 1.242 0 2.124-.198 2.646-.594.522-.396.783-.891.783-1.485 0-.486-.18-.891-.54-1.215-.36-.324-1.008-.585-1.944-.783l-2.97-.648c-3.276-.72-4.914-2.466-4.914-5.238 0-1.512.513-2.79 1.539-3.834 1.026-1.044 2.403-1.701 4.13-1.971V2.62c0-.45.154-.828.46-1.134.306-.324.693-.486 1.16-.486.45 0 .829.162 1.135.486.306.306.459.684.459 1.134v1.62c.666.09 1.35.252 2.052.486a7.1 7.1 0 0 1 1.89.918c.432.27.693.621.783 1.053.108.414.072.81-.108 1.188-.18.378-.477.648-.891.81-.396.144-.882.072-1.458-.216a9.753 9.753 0 0 0-1.593-.594c-.576-.162-1.287-.243-2.133-.243-1.044 0-1.863.216-2.457.648-.594.432-.891.99-.891 1.674 0 .486.17.891.513 1.215.36.306.98.558 1.863.756l2.997.648c1.71.378 2.97.999 3.78 1.863.828.846 1.242 1.935 1.242 3.267 0 1.53-.522 2.79-1.566 3.78-1.026.99-2.367 1.629-4.023 1.917v1.701c0 .45-.153.828-.46 1.134a1.498 1.498 0 0 1-1.133.486Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar28);
export default __webpack_public_path__ + "static/media/dollar_28.e29232e1.svg";
export { ForwardRef as ReactComponent };